module.exports = __webpack_public_path__ + "static/storage-base-2-1ae2968b916719bba88cf0c4c5577c08.mp4";